module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_edito.75ae2d7be1878678d20a92bd44dca02f.png";